import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

export const PromoCodeContainer = styled.div`
  width: 220px;
  padding: 0 0 25px;

  ${mediaQueries.tablet`
    width: 100%;
  `};
`
export const PromoCodeLabel = styled.label`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.doveGray};

  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
`

export const InputLabel = styled.span`
  padding: 15px 0;
`
